import { render } from "./RefinementListSlider.vue?vue&type=template&id=7064ce34"
import script from "./RefinementListSlider.vue?vue&type=script&lang=js"
export * from "./RefinementListSlider.vue?vue&type=script&lang=js"

import "./RefinementListSlider.vue?vue&type=style&index=0&id=7064ce34&lang=css"

import exportComponent from "/home/runner/work/brekz-prestashop/brekz-prestashop/web/themes/brekz-2017/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__